import styled from "@mui/material/styles/styled";
import Typography, { TypographyProps } from "@mui/material/Typography";

const Badge = styled(Typography)(({ theme }) => ({
  borderRadius: theme.corners.small,
  width: "fit-content",
  background: theme.palette.gradients.read,
  padding: "4px 6px",
  color: "#FFF",
  textTransform: "uppercase",
  fontWeight: 500,
}));

type FeatureBadgeProps = TypographyProps & { icon: string };

const FeatureBadge = ({
  children,
  icon,
  variant = "labelMed",
  ...typographyProps
}: FeatureBadgeProps) => (
  <Badge variant={variant} {...typographyProps}>
    {icon}&nbsp;{children}
  </Badge>
);

export const NewBadge = () => <FeatureBadge icon="✨">NEW!</FeatureBadge>;

export default FeatureBadge;
